import { Badge } from '@mantine/core'

export type Severity = 'info' | 'warning' | 'critical'

const COLOR: Record<Severity, string> = {
  info: 'gray',
  warning: 'yellow',
  critical: 'red',
}

export function SeverityBadge({ severity }: { severity?: Severity }) {
  const sev = severity ?? 'info'
  return <Badge size="sm" color={COLOR[sev]} variant="light">{sev}</Badge>
}
